import { useContext } from 'react';

import { CreatePostModalContext } from 'src/contexts/CreatePostModalProvider';

const useCreatePost = () => {
    const createPost = useContext(CreatePostModalContext);
    return createPost;
};

export default useCreatePost;
